import React from 'react';
import {
  ImagePreview,
  FileName,
} from 'components/file-input/components/file-preview/style';
import { usePrevious } from 'hooks';

export interface FilePreviewProps {
  file: File;
}

function FilePreview({ file }: FilePreviewProps) {
  const [selectedFileUrl, setSelectedFileUrl] = React.useState<any>(null);
  const previousSelectedFileUrl = usePrevious(selectedFileUrl);

  const isImage = file.type.includes('image/');
  const isPdf = file.type === 'application/pdf';
  const isVideo = file.type === 'video/mp4';

  React.useEffect(() => {
    if (isImage) {
      setSelectedFileUrl(URL.createObjectURL(file));
    }
  }, [file, isImage]);

  React.useEffect(() => {
    revokeObjectUrlIfExists(previousSelectedFileUrl);

    return () => revokeObjectUrlIfExists(selectedFileUrl);
  }, [selectedFileUrl]);

  function revokeObjectUrlIfExists(url) {
    if (url) {
      URL.revokeObjectURL(url);
    }
  }

  if (isImage) {
    return <ImagePreview src={selectedFileUrl} />;
  }

  if (isPdf) {
    return <FileName>{file.name}</FileName>;
  }

  if (isVideo) {
    return <FileName>{file.name}</FileName>;
  }

  return null;
}

export default FilePreview;
